<template>
  <b-card style="z-index: 10" class="sticky-top" body-class="px-5" footer-bg-variant="light">

    <b-row class="mb-5">
      <b-col>
        <b-img :src="this.$getConst.images.logo_default" width="100" class="float-left"/>
      </b-col>
    </b-row>

    <h2 class="text-primary text-uppercase font-weight-bold">{{emailTemplateForm.title}}</h2>
    <h3 class="text-secondary text-uppercase font-weight-bold mb-5">{{emailTemplateForm.subtitle}}</h3>

    <div v-html="emailTemplateForm.introduction"/>

    <b-row v-if="displayTable" class="mb-2">
      <b-col>
        <b-img :src="this.$getConst.images.emailTemplateOverviewContent" class="w-100"/>
      </b-col>
    </b-row>
    <b-row v-if="displayInvoiceTable" class="mb-2">
      <b-col>
        <b-img :src="this.$getConst.images.invoicesEmailTemplateOverviewContent" class="w-100"/>
      </b-col>
    </b-row>
    <b-row v-if="displayComment" class="mb-2">
      <b-col>
        <b-img :src="this.$getConst.images.emailTemplateOverviewComment" class="w-100"/>
      </b-col>
    </b-row>

    <div>
      <button
        v-if="emailTemplateForm.button_review_label"
        disabled
        class="email-btn mb-2 mr-2"
        :style="'background-color: '+ (emailTemplateForm.button_review_color ? emailTemplateForm.button_review_color : '#000000')"
      >
        {{emailTemplateForm.button_review_label}}
      </button>
      <button
        v-if="emailTemplateForm.button_approve_label"
        disabled
        class="email-btn mb-2 mr-2"
        :style="'background-color: '+ (emailTemplateForm.button_approve_color ? emailTemplateForm.button_approve_color : '#000000')"
      >
        {{emailTemplateForm.button_approve_label}}
      </button>
      <button
        v-if="emailTemplateForm.button_reject_label"
        disabled
        class="email-btn mb-2 mr-2"
        :style="'background-color: '+ (emailTemplateForm.button_reject_color ? emailTemplateForm.button_reject_color : '#000000')"
      >
        {{emailTemplateForm.button_reject_label}}
      </button>
    </div>

    <div v-html="emailTemplateForm.button_description"/>

    <button
      v-if="emailTemplateForm.button_principal_label"
      disabled
      class="email-btn mb-2 mr-2"
      :style="'background-color: '+ (emailTemplateForm.button_principal_color ? emailTemplateForm.button_principal_color : '#000000')"
    >
      {{emailTemplateForm.button_principal_label}}
    </button>

    <div v-html="emailTemplateForm.ending"/>

    <template #footer>
      <p class="mb-0 font-weight-bold px-3" v-html="footer">
      </p>
    </template>
  </b-card>
</template>

<script>
  export default {
    name: "emailTemplateOverview",
    props: {
      emailTemplateForm: {
        subject: null,
        title: null,
        subtitle: null,
        introduction: null,
        buttonDescription: null,
        button_principal_label: null,
        button_review_label: null,
        button_approve_label: null,
        button_reject_label: null,
        button_principal_color: null,
        button_review_color: null,
        button_approve_color: null,
        button_reject_color: null,
        ending: null,
      },
      language: {
        type: Object,
        defaul: {
          code: null,
          name: null,
          id: null
        }
      },
      displayTable: {
        type: Boolean,
        default: true
      },
      displayComment: {
        type: Boolean,
        default: true
      },
      displayInvoiceTable: {
        type: Boolean,
        default: false
      },
    },
    data() {
      return {
        footer: ''
      }
    },
    watch: {
      language: {
        handler() {
          this.footer = (this.$t(this.$getConst.pages.email_template.email_template_footer, this.language.code)).replace('{{actualYear}}', new Date().getFullYear())
        },
        deep: true,
      }
    }
  }
</script>

<style>
@import './email-template-overview.scss';
</style>
